import { createRouter, createWebHistory } from "@ionic/vue-router";
import { RouteRecordRaw } from "vue-router";
import { UserStorage } from "@/storage/user.storage";

const userStorage = new UserStorage();

const routes: Array<RouteRecordRaw> = [
  // DEFAULT LAYOUT
   // ROTA DE LOGIN
   {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login.vue"),
  },
  {
    path: "",
    redirect: "/login",
    component: () => import("@/layouts/default.vue"),
    children: [
      {
        path: "/home",
        component: () => import("@/views/home.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/about",
        component: () => import("@/views/about.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/produtos/:comandaUuid/:comandaNome",
        name: "Produtos",
        component: () => import("@/views/produtos.vue"), // Componente de Produtos
        props: true, // Passa o `comandaId` como prop
        meta: { requiresAuth: true },
      },
    ],
  },

  // NOT FOUND
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: () => import("@/views/not-found.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Verifica se o usuário está autenticado
const isLoggedIn = () => {
  const user = userStorage.getUser();
  return user && user.token;
};

// Guard global para verificar autenticação
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  if (requiresAuth && !isLoggedIn()) {
    next("/login");
  } else if (!requiresAuth && isLoggedIn() && to.path === "/login") {
    next("/home");
  } else {
    next();
  }
});

export default router;
